var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpaceSpecialtyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9998 11.4743L0.730469 3.94834L2.53847 0.333008H11.4611L13.2691 3.94834L6.9998 11.4743ZM4.8778 3.66634H9.1218L7.78847 0.999674H6.21114L4.8778 3.66634ZM6.66647 10.0397V4.33301H1.9278L6.66647 10.0397ZM7.33314 10.0397L12.0718 4.33301H7.33314V10.0397ZM9.86114 3.66634H12.3718L11.0385 0.999674H8.5278L9.86114 3.66634ZM1.6278 3.66634H4.13847L5.4718 0.999674H2.96114L1.6278 3.66634Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceSpecialtyIcon);
export default __webpack_public_path__ + "static/media/space-specialty-icon.c9fb9bd24de46e16cfe88f469b4e285e.svg";
export { ForwardRef as ReactComponent };